<div class="export-calls">
  <div class="export-row" *ngIf="isIncludeTeams">
    <div class="checkbox-text">{{ "__CALLS_ALL_TEAMS__" | translate }}</div>
    <ion-toggle
      [checked]="includeTeams"
      (ionChange)="changeIncludeTeams()"
      mode="ios"
    ></ion-toggle>
  </div>
  <div class="export-row">
    <div class="checkbox-text">{{ "__CALLS_GROUP_BY_AGENTS__" | translate }}</div>
    <ion-toggle
      [checked]="groupByAgents"
      (ionChange)="groupByAgents = !groupByAgents"
      mode="ios"
    ></ion-toggle>
  </div>
  <div class="export-row">
    <button class="btn btn-primary" (click)="exportCalls()">
      {{ "__CALLS_EXPORT_CALLS__" | translate }}
    </button>
  </div>
</div>
